import React, {useEffect, useState} from "react";
import $ from 'jquery';
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import "../../assets/css/pages/sellers.css";
import axios from "axios";
import swal from "sweetalert";
import ReactSelectInput from "../../Components/Inputs/ReactSelectInput";
import {useForm} from "react-hook-form";

const yesNoOptions = [
  {id: 0, name: 'No'},
  {id: 1, name: 'Yes'},
];

export default function () {
  const navigate = useNavigate();
  const token = useSelector(state => state.token);
  const {control, watch} = useForm({
    defaultValues: {show_disabled: 0}
  });

  useEffect(() => {
    const baseUrl = process.env.REACT_APP_API_URL;

    let table = $('#sellers').DataTable({
      "destroy": true,
      "ajax": {
        url: baseUrl + "shops",
        method: 'GET',
        data: {
          'show_disabled': watch('show_disabled')
        },
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", 'Bearer ' + token);
        },
        error: function (xhr) {
          if (xhr?.status === 401) {
            axios.defaults.baseURL = process.env.REACT_APP_API_CLEAN_URL;
            axios.post('/logout')
              .then(
                localStorage.removeItem('persist:root'),
                navigate('/login')
              );
          }
        }
      },
      "columns": [
        {
          data: 'checkbox',
          searchable: false,
          orderable: false,
          defaultContent: '<input type="checkbox" class="form-check-input cursor-pointer" name="chkbx1" value="col0">',
          className: 'checks col0'
        },
        {data: 'id', name: 'id'},
        {
          data: 'shop_name', name: 'shop_name',
          render: function (data, type, row) {
            return `<button type="button" class="btn btn-link edit" row-id="${row.id}">
              ${row.shop_name}
            </button>`
          }
        },
        {data: 'shop_identification_code', name: 'shop_identification_code'},
        {data: 'email', name: 'email'},
        {
          data: 'is_active',
          name: 'is_active',
          render: function (data, type, row) {
            return row.is_active ? 'active' : 'de-activated';
          }
        },
      ],
      "order": [[0, "desc"]],
    });

    table.on('click', 'button.edit', function () {
      const id = $(this).attr("row-id");
      navigate(`/shops/${id}/edit`);
    });

    // Return checked checkboxes from an array of checkboxes
    function checkedTargets(checkboxes) {
      return checkboxes.filter(function (index) {
        return $(checkboxes[index]).prop('checked');
      });
    }

    $('#active').on('click', function () {
      var data = table.rows(function (idx, data, node) {
        // Get all the checkboxes in the row
        var cells = $(node).find('input[type="checkbox"]');
        // Keep the rows with checked checkboxes
        return checkedTargets(cells).length;
      })
        .data()
        .toArray();

      let shopsIds = [];

      data.forEach(item => {
        if (item.shop_id) {
          shopsIds.push(item.shop_id);
        }
      });

      statusesUpdate(shopsIds, true);
    });

    $('#de-active').on('click', function () {
      var data = table.rows(function (idx, data, node) {
        // Get all the checkboxes in the row
        var cells = $(node).find('input[type="checkbox"]');
        // Keep the rows with checked checkboxes
        return checkedTargets(cells).length;
      })
        .data()
        .toArray();

      let shopsIds = [];

      data.forEach(item => {
        if (item.shop_id) {
          shopsIds.push(item.shop_id);
        }
      });

      statusesUpdate(shopsIds, false);
    });

    const statusesUpdate = (shops, status) => {
      axios.put('shops/statuses/update', {shops, status},
      ).then(res => {
        if ($("#sellers #select-all").is(":checked")) {
          $("#sellers #select-all").click();
        }
        table.draw(false);
      }).catch(onerror => {
        swal('Something went wrong!', {
          icon: "error",
        });
        console.log('ERROR : ' + onerror.message());
      })
    }

    // Handle click on "Select all" control
    $('#select-all').on('click', function () {
      // Check/uncheck all checkboxes in the table
      var rows = table.rows({'search': 'applied'}).nodes();
      $('input[type="checkbox"]', rows).prop('checked', this.checked);
    });

    let datatableSearch = ".dataTables_wrapper .dataTables_filter input[type=search]";
    $("<i class='fas fa-search'></i>")
      .insertBefore(datatableSearch);
    $(datatableSearch)
      .attr("placeholder", "Search...");


  }, [watch('show_disabled')]);

  const addSeller = () => {
    navigate('/shops/create');
  }

  return (
    <div>
      <div className="d-flex flex-stack mb-5">
        <div className="d-flex justify-content-end" data-kt-docs-table-toolbar="base">
          <button type="button" className="btn btn-primary" data-bs-toggle="tooltip" title="Coming Soon"
                  onClick={addSeller}>
            <i className="fas fa-plus-circle fs-5 mr-2"></i>
            Add Seller
          </button>
        </div>
      </div>
      <div className="d-flex flex-stack mb-5">
        <div className="d-flex justify-content-end" data-kt-docs-table-toolbar="base">
          <button type="button" className="btn btn-success" title="Coming Soon" id="active">
            <i class="fas fa-check-circle fs-5 mr-2"></i>
            Active
          </button>
          <button type="button" className="btn btn-danger ml-3" title="Coming Soon" id="de-active">
            <i class="fas fa-times-circle fs-5 mr-2"></i>
            Deactivate
          </button>
        </div>
        <ReactSelectInput
          label="Show deactivated"
          inputClassName="col-xxl-3 col-lg-4 mb-5"
          name="show_disabled"
          placeholder="Choose"
          defaultValue={0}
          options={yesNoOptions}
          control={control}
        />
      </div>
      <table id="sellers" className="table align-middle table-row-dashed fs-6 gy-5">
        <thead>
        <tr className="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">

          <th><input id="select-all" type="checkbox" className={'form-check-input cursor-pointer mt-3 mx-2'}/></th>
          <th>ID</th>
          <th>Name</th>
          <th>Identification Code</th>
          <th>Email</th>
          <th>Status</th>
        </tr>
        </thead>
        <tbody className="text-gray-600 fw-bold"></tbody>
      </table>
    </div>
  );
}